import ServerVariablesTextbox_vue_vue_type_script_setup_true_lang_default from "./ServerVariablesTextbox.vue.script.js";
//#region src/components/Server/ServerVariablesTextbox.vue
var ServerVariablesTextbox_default = ServerVariablesTextbox_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ServerVariablesTextbox_default as default };

//# sourceMappingURL=ServerVariablesTextbox.vue.js.map